import { render } from "./LanguageFlagDisplay.vue?vue&type=template&id=6070c39e&scoped=true"
import script from "./LanguageFlagDisplay.vue?vue&type=script&lang=js"
export * from "./LanguageFlagDisplay.vue?vue&type=script&lang=js"

import "./LanguageFlagDisplay.vue?vue&type=style&index=0&id=6070c39e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6070c39e"

export default script